module.exports = __webpack_public_path__ + "static/media/add_tag_desktop.789b7100.svg";